import useEntity from "../../hooks/useProvider";
import ProviderDetail from "../../components/provider/ProviderDetail/ProviderDetail";
import ProviderScoped from "../../components/provider/ProviderDetail/ProviderScoped";
import ProviderTabs from "../../components/provider/ProviderDetail/ProviderTabs";
import { useGetProviderQuery } from "../../apis/Provider.api";
import { PrimaryProvider } from "../../types/models/Provider";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ProviderDetailPage = () => {

    useTitle(t`Details Provider`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { providerId: id } = useParams();

    const { data, refetch } = useGetProviderQuery(PrimaryProvider.fromPath(id))
    const { deleteProvider } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteProvider(data, '..')
    }, [data, deleteProvider])

    if (id === 'scoped') {
        return (<ProviderScoped/>)
    }

    return (
        <Box data-testid="Provider-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ProviderDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Providers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="Provider-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Providers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="Provider-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ProviderTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ProviderDetailPage;
